import PubSub from "pubsub-js";
import {
  Bad_request,
  Error_limited,
  Forbidden,
  Gateway_timeout,
  Internal_server_error,
  Service_unavailable,
  Unauthorized,
} from "../service/esiclient";

export function HandleEsiError(error: unknown, character_id?: number, function_name?: string) {
  const forString = character_id ? " for " + character_id : "";
  console.error(error);
  if (error instanceof Forbidden) {
    PubSub.publish("ERROR", "Forbidden Error - " + function_name + forString + " : " + error?.error);
  } else if (error instanceof Error_limited) {
    PubSub.publish("ERROR", "Limited Error - " + function_name + forString + " : " + error?.error);
  } else if (error instanceof Gateway_timeout) {
    PubSub.publish("ERROR", "Timeout - " + function_name + forString + " : " + error?.error);
  } else if (error instanceof Internal_server_error) {
    PubSub.publish("ERROR", "Server error - " + function_name + forString + " : " + error?.error);
  } else if (error instanceof Service_unavailable) {
    PubSub.publish("ERROR", "Service unavailable - " + function_name + forString + " : " + error?.error);
  } else if (error instanceof Unauthorized) {
    PubSub.publish("ERROR", "Unauthorized - " + function_name + forString + " : " + error?.error);
  } else if (error instanceof Bad_request) {
    PubSub.publish("ERROR", "Bad Request - " + function_name + forString + " : " + error?.error);
  } else PubSub.publish("ERROR", "Unknown error fetching " + function_name + forString);
}
